module.exports = __webpack_public_path__ + "17909e3784b7d4ef90efeae63ef194b4.svg";